import React from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { bindActionCreators } from 'redux'
import { hideSidebar } from 'redux/navigation'
import { Icon, Label, Menu } from 'semantic-ui-react'

const mapStateToProps = (state, ownProps) => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      push,
      hideSidebar,
    },
    dispatch
  )
}

class NavigationSubmenuDropDown extends React.Component {
  render() {
    const { items, push, hideSidebar } = this.props

    const menuItems = items.map((item) => (
      <Menu.Item
        {...{
          active: item.active,
          color: item.color,
          href: item.path,
          key: item.key,
          onClick: (event) => {
            event.preventDefault()
            push(item.path)
            hideSidebar()
          },
        }}>
        {item.badge ? (
          <Label color="red" className="badge">
            {item.badge}
          </Label>
        ) : (
          ''
        )}
        <Icon name={item.icon} />
        {item.content}
      </Menu.Item>
    ))

    return menuItems ? <Menu.Menu size="small">{menuItems}</Menu.Menu> : false
  }
}

NavigationSubmenuDropDown = connect(mapStateToProps, mapDispatchToProps)(
  NavigationSubmenuDropDown
)
export default NavigationSubmenuDropDown



// WEBPACK FOOTER //
// ./src/components/shared/Navigation/renditions/NavigationSubmenuDropdown.jsx